<template>
    <div>
        <v-data-table
            :headers="allHeaders"
            :items="items"
            hide-default-footer
            :header-props="{ sortIcon: '' }"
            :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
            :no-results-text="$t('lang_GENERAL_LOADING_DATATABLE')"
            class="noMinWidth"
            :items-per-page="itemsPerPage"
        >
            <!-- Top Slot -->
            <template v-slot:top>
                <v-row class="pb-3">
                    <slot name="top"></slot>
                </v-row>
            </template>

            <!-- Headers -->
            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                <!-- mouseover on headlines -->
                <span v-if="header.mouseover !== undefined" :key="i">
                    <BaseTooltip>
                        <template v-slot:content>
                            {{ header.text }}
                            <v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon>
                        </template>
                        <template v-slot:text :alvqa="header.alvqa">
                            <span>{{ header.mouseover }}</span>
                        </template>
                    </BaseTooltip>
                </span>
                <span v-else :alvqa="header.alvqa" :key="header.value">{{ header.text }}</span>
            </template>

            <!-- Items -->
            <template v-slot:item="{ item }">
                <tr>
                    <slot name="body" :item="{ item }"></slot>

                    <!-- Edit Button -->
                    <td>
                        <BaseIcon   
                            :alvqa="alvqa + '-list-row-icon-inline-edit'"
                            icon="edit" 
                            tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                            @click.stop="editingFunction(item)"
                        />
                    </td>
                    <td>
                        <BaseIcon 
                            @click="deleteFunction(item)"
                            icon="delete"
                            color="iconDelete"
                            tooltipText="lang_GENERIC_CAPTION_DELETE"
                            :alvqa="alvqa + 'list-row-icon-delete'"
                        />
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import VDataTable from 'vuetify/es5/components/VDataTable'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseEditDataTable",
    extends: VDataTable,
    props: {
        headers: {
            required: true,
            type: Array,
            default: []
        },
        items: {
            required: true,
            type: Array,
            default: []
        },
        alvqa: {
            type: String,
            default: ''
        },
        deleteFunction: {
            type: Function,
            default: () => {}
        },
        editingFunction: {
            type: Function,
            default: () => {}
        },
    },
    components: {
        BaseIcon,
        BaseTooltip
    },
    computed: {
        allHeaders() {
            let allHeaders = [
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    width: "70px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-headers-edit'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-headers-delete'
                }
            ]


            for (let index = this.headers.length-1; index >= 0; index--) {
                allHeaders.unshift(this.headers[index])
            }
            
            return allHeaders
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    }
}
</script>